import React, { Component } from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
class Iframe extends Component {
  render() {
    const iframeSrc = this.props.location.pathname.split("link=")[1];
    // let frameStyle = obj.iframeHeight;
    // if (this.props.auth.user) {
    //   frameStyle = obj.userIframeHeight;
    // }
    return (
      <div style={{ WebkitOverflowScrolling: "touch" }}>
        <iframe
          style={{ height: "calc(100vh - 168px - 78px)" }}
          src={iframeSrc}
          width="100%"
          title={iframeSrc}
          className="iframe"
          seamless
          border="0"
          frameBorder="0"
          sandbox="allow-same-origin allow-scripts"
        />
      </div>
    )
  }
}

// const obj = {
//   iframeHeight: {
//     height: "calc(100vh - 168px - 76px)"
//   },
//   userIframeHeight: {
//     height: "calc(100vh - 168px - 76px)"
//   }
// }
Iframe.propTypes = {
  location: PropTypes.object,
}

function mapStateToProps(state) {
  const { auth } = state;
  return { auth };
}
// export default Iframe;
export default connect(mapStateToProps)(Iframe);